<template>
  <div class="share-page-layout layers" :class="{ eng: SC.U === ENG, chi: SC.U === CHI }">
    <div class="scroller" ref="scroller">
      <div class="long-content" ref="content">
        <div class="top-taller"></div>

        <div class="single-col">
          <div class="single-row spark-title-row">
            <div class="spark-title-con">{{ T('/share-page@title-1') }}{{ T('/share-page@title-2') }}{{ T('/share-page@title-3') }}</div>
          </div>
          <div class="single-row share-image-row">
            <div class="share-image">
              <EffectFilter class="share-image-target" @home="$router.push('/')" />
            </div>
          </div>

          <div class="share-box-row">
            <div class="share-box">
              <img class="share-frame mobile-share" src="./ShareDialogue/img/share-frame.svg" alt="">
              <img class="share-frame desktop-share" src="./ShareDialogue/img/share-frame-desktop.svg" alt="">

              <div class="share-to">
                <span v-if="SC.U === ENG">Share To</span>
                <span v-if="SC.U === CHI">分享至</span>
              </div>
              <div class="share-icons">
                <img class="pointer facebook" src="./ShareDialogue/img/fb.svg" @click="fbShare" alt="">
                <img class="pointer whatsapp" src="./ShareDialogue/img/whatsapp.svg" @click="whatsappShare" alt="">
                <img class="pointer" src="./ShareDialogue/img/sina.svg" @click="sinaShare" alt="">
              </div>
              <div class="share-hashtag">
                <div class="click-to-download" v-if="SC.U === CHI" :style="{ 'font-size': '14px' }">
                  可輕按相片至儲存頁面
                </div>
                <div class="click-to-download" v-if="SC.U === ENG" :style="{ 'font-size': '14px' }">
                  Please click the photo to save
                </div>
                #radianceis #cledepeauhk #makeawishhk
              </div>
            </div>
          </div>

          <!-- <div class="single-row share-cta-row">
            <div class="share-cta" @click="shareDialogue = true">
              <img class="share-cta-frame" src="./img/cta-frame.svg" />
              <div class="share-cta-text">
                {{ T('/share-page@cta-text') }}
              </div>
            </div>
          </div> -->

          <div class="single-row about-wish-row" @click="aboutKidsWishes">
            <span class="about-wish">
              {{ T('/share-page@kids-wishes') }}
            </span>
          </div>

        </div>
        <!-- Single Column -->

        <!-- <Counter :ready="show.counter" :now="3456" :full="5000" :daysToGo="15" :delay="0" /> -->
        <!-- <div class="counter-bottom-padding"></div> -->

        <!-- Counter old -->
        <div class="counter-col" :class="{ fadeIn: runTweenCounter }">
          <div class="counter-top-padding"></div>
          <div class="single-col">
            <div class="single-row thank-you">
              {{ T('/share-page@thanks-for-joining-1') }} <span class="number">5000</span>
              {{ T('/share-page@thanks-for-joining-2') }}
            </div>
            <div class="single-row radiance-collected">
              {{ T('/share-page@collected') }}
            </div>
            <div class="single-row radiance-collected-count">
              {{ collected.toFixed(0) }}
            </div>
            <div class="single-row v-line-row">
              <div class="v-line"></div>
            </div>
            <div class="single-row days-to-go">
              {{ T('/share-page@remain') }}
            </div>
            <div class="single-row days-to-go-count">
              {{ daysToGo }}
            </div>
          </div>
          <div class="counter-bottom-padding"></div>
        </div>

        <div class="bottom-taller"></div>
        <!-- <div class="taller"></div>
        <div class="taller"></div> -->
      </div>
    </div>
    <FloatMenu class="float-menu" @diamond="() => { fsMenu = !fsMenu }" />
    <FullMenu class="full-menu" v-show="fsMenu" @close="() => { fsMenu = false }" @lang="() => { Text.toggle() }" />
    <!-- <ShareDialogue class="share-dialogue" v-show="shareDialogue" @close="() => { shareDialogue = false }" /> -->
  </div>
</template>

<script>
import Counter from '@/components/DOM/Counter/Counter.vue'
import EffectFilter from '@/components/DOM/EffectFilter/EffectFilter.vue'
import FloatMenu from '@/components/DOM/FloatMenu/FloatMenu.vue'
import FullMenu from '@/components/DOM/FullMenu/FullMenu.vue'
// import ShareDialogue from './ShareDialogue/ShareDialogue.vue'
import * as Text from '@/components/DOM/Text/Text.js'
import * as Server from '@/components/DOM/Server/Server.js'

import * as ScrollMonitor from '@/components/Parts/ScrollMonitor/ScrollMonitor.js'

// import Instruction from './Instruction.vue'
var TWEEN = require('@tweenjs/tween.js')

export default {
  components: {
    Counter,
    FloatMenu,
    FullMenu,
    // ShareDialogue,
    EffectFilter

    // Instruction
  },
  data () {
    let fbCN = `参加Clé de Peau Beauté #radianceis 活动，开启源自内在的闪耀力量，传承臻丽耀光。 radianceis.com.hk #radianceis #cledepeauhk #makeawishhk`
    let fbCHI = `參加Clé de Peau Beauté #radianceis 活動，開啟源自內在的閃耀力量，傳承臻麗耀光。radianceis.com.hk #radianceis #cledepeauhk #makeawishhk`
    let fbENG = `Clé de Peau Beauté believes the radiance is not just skin deep, it comes from within. Unlock your radiance and shine on others.
    #radianceis #cledepeauhk #makeawishhk`

    let daysToGo = 0

    var now = new Date().getTime()
    var countDownDate = new Date('April 29, 2018 23:59:00').getTime()

    var diff = countDownDate - now

    var days = Math.ceil(diff / (1000 * 60 * 60 * 24))

    daysToGo = days

    if (days > 27) {
      daysToGo = 27
    }
    if (days < 0) {
      daysToGo = 0
    }

    return {
      Text,
      fbCHI,
      fbENG,
      fbCN,

      SC: Text.state,
      T: Text.T,
      ENG: Text.ENG,
      CHI: Text.CHI,

      shareDialogue: false,
      fsMenu: false,
      clean () {},
      show: {
        counter: false
      },
      full: 5000,
      now: 0,
      collected: 0,

      sharedCheck: {
        fb: false,
        sina: false,
        whatsapp: false
      },

      daysToGo,
      runTweenCounter: false
    }
  },
  watch: {
    runTweenCounter () {
      if (this.runTweenCounter) {
        this.tweenCounter()
      }
    }
  },
  mounted () {
    ScrollMonitor.setPercentage(0)
    this.setupScroll()
    window.addEventListener('resize', () => {
      this.setupScroll()
    })
    if (window.innerWidth > 450) {
      setTimeout(() => {
        this.show.counter = true
        this.runTweenCounter = true
        this.tweenCounter()
      }, 1000)
    }
  },
  methods: {
    tweenCounter () {
      Server.getRadianceCount().then(({ count }) => {
        this.now = count
        let tween = new TWEEN.Tween(this)
          .to({ collected: this.now }, 3333)
          .easing(TWEEN.Easing.Quadratic.Out)

        tween.start()
      })
    },
    fbShare () {
      Server.recordStep({ step: 3 }).then(({ status }) => {
        if (!this.sharedCheck.fb && status === 'ok') {
          this.sharedCheck.fb = true
          this.collected += 1
        }
      })
      /*
      */

      let locale = Text.state.U === Text.ENG ? 'en' : 'zh'
      // // window.alert(('https://radianceis.com.hk' + Server.Store.shareLink + '&lang=' + locale))

      /* eslint-disable */
      var share_facebook = () => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        // Dynamically gather and set the FB share data.
        var FBDesc      = Text.state.U === Text.ENG ? this.fbENG : this.fbCHI;
        var FBTitle     = 'Radiance is';
        var FBLink      = 'https://radianceis.com.hk' + Server.Store.shareLink + '&lang=' + locale;
        var FBPic       = 'https://radianceis.com.hk/upload/' + Server.Store.shareID + '-social.png';

        console.log(FBDesc)

        // // Open FB share popup d
        // FB.ui({
        //     method: 'share',
        //     action_type: 'og.shares',
        //     action_properties: JSON.stringify({
        //         object: {
        //             'og:url': FBLink,
        //             'og:title': FBTitle,
        //             'og:description': FBDesc,
        //             'og:image': FBPic
        //         }
        //     })
        // },
        // function(response)
        // {
        //   //response codes
        // });

        window.FB.ui({
          method: 'share',
          display: 'popup',
          // href: ('https://radianceis.com.hk' + Server.Store.shareLink + '&lang=' + locale),
          href: FBLink,
          // hashtag: '#clédepeauhk #radianceis #makeawishhk',
          hashtag: '#radianceis' // ,
          // quote: this.SC.U === this.ENG ? fbENG : fbCHI
        }, (response) => {
        })

      }
      share_facebook()

      /* eslint-enable */

      // window.alert('require server for facebook share' + '\n' + fbCHI + '\n' + fbENG)
    },
    sinaShare () {
      Server.recordStep({ step: 5 }).then(({ status }) => {
        if (!this.sharedCheck.sina && status === 'ok') {
          this.sharedCheck.sina = true
          this.collected += 1
        }
      })

      let locale = Text.state.U === Text.ENG ? 'en' : 'zh'
      var FBLink = 'https://radianceis.com.hk' + Server.Store.shareLink + '&lang=' + locale
      let url = encodeURIComponent(FBLink)
      let text = encodeURIComponent(this.fbCN)
      let image = encodeURIComponent('https://radianceis.com.hk/upload/' + Server.Store.shareID + '-avatar.png')
      // console.log('https://radianceis.com.hk/upload/' + Server.Store.shareID + '-avatar.png')

      let link = `http://service.weibo.com/share/share.php?url=${url}&appkey=&title=${text}&pic=${image}&ralateUid=`
      // let link = `http://service.weibo.com/share/share.php?appkey=&title=${text}&pic=${image}&ralateUid=`

      var href = document.createElement('a')
      href.href = link
      href.target = '_blank'
      href.click()

      //  window.alert('require server to host image for sina share')

      // http://service.weibo.com/share/share.php?url=wonglok.com&appkey=&title=WONGLOKWEB&pic=https://picsum.photos/200/300/?random&ralateUid=
      console.log(link)
      // http://service.weibo.com/share/share.php?url=&appkey=&title=
      // <a href="http://service.weibo.com/share/share.php?url=<?php the_permalink() ?>">target="_blank">
      // <img style="border: 0;" src="http://wordpress-tw.marcpov.com/wp-content/uploads/WeiboButton.png" alt="sina-weibo" width="131" height="34" />
      // </a>
    },
    whatsappShare () {
      Server.recordStep({ step: 4 }).then(({ status }) => {
        if (!this.sharedCheck.whatsapp && status === 'ok') {
          this.sharedCheck.whatsapp = true
          this.collected += 1
        }
      })

      let locale = Text.state.U === Text.ENG ? 'en' : 'zh'
      let link = 'https://radianceis.com.hk' + Server.Store.shareLink + '&lang=' + locale

      // window.alert('require server to host the image to share that image on whatsapp.')
      let text = (Text.state.U === Text.ENG ? this.fbENG : this.fbCHI.replace('radianceis.com.hk ', '')) + ' ' + link
      console.log(text)
      text = encodeURIComponent(text)

      // <a href="Hello%2C%20World!">Send message to WhatsApp</a>
      var href = document.createElement('a')
      href.href = `whatsapp://send?text=${text}`
      href.click()
    },
    aboutKidsWishes () {
      this.$router.push('/kids-wishes')
    },
    setupScroll () {
      this.clean()
      var scroller = this.$refs['scroller']
      if (!scroller) {
        return
      }
      var content = this.$refs['content']
      var scrollerHeight = scroller.getBoundingClientRect().height
      var ccontentHeight = content.getBoundingClientRect().height
      var onScroll = () => {
        this.scrollPos = scroller.scrollTop

        if (this.scrollPos > 300) {
          this.show.counter = true
          this.runTweenCounter = true
        }

        ScrollMonitor.state.percentage = 0.05 * (scroller.scrollTop) / (ccontentHeight - scrollerHeight)
        // console.log(ScrollMonitor.state.percentage)
      }
      scroller.addEventListener('scroll', onScroll, false)

      this.clean = () => {
        if (scroller) {
          scroller.removeEventListener('scroll', onScroll)
        }
      }
    }
  },
  beforeDestroy () {
    this.clean()
  }
}
</script>

<style scoped>
.share-page-layout{
  color: white;
}
.full-menu{
  position: absolute;
  top: 0px;
  left: 0px;
}
.float-menu{
  position: absolute;
  top: 0px;
  left: 0px;
}
.share-dialogue{
  position: absolute;
  top: 0px;
  left: 0px;
}
.layers{
  width: 100%;
  height: 100%;
  position: relative;
  overflow:hidden;
}

.scroller{
  position: absolute;
  top: 0px;
  left: 0px;

  width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  color: white;
}
.top-taller{
  height: 90px;
}
.taller{
  height: 75vh;
}

.bottom-taller{
  height: 0px;
}

.single-col{
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  flex-wrap: wrap;
}
.single-row{
  width: 100%;
  max-width: 300px;
}

@media screen and (min-width: 374px) {
  .single-row{
    max-width: 350px;
  }
}
@media screen and (min-width: 413px) {
  .single-row{
    max-width: 380px;
  }
}

.spark-title-row{
  margin-top: 15px;
}

.spark-title-con{
  white-space: pre-line;
  text-transform: uppercase;
  /* Thank you for your p: */
  /* border: 1px solid #FFFFFF; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 1.8px;
  text-align: center;
  line-height: 20px;
}

@media screen and (min-width: 374px) {
  .spark-title-con{
  }
}
@media screen and (min-width: 413px) {
}

.share-image-row{
  margin-top: 20px;
}
.share-image{
  display: flex;
  justify-content: center;
  align-items: center;
}
.share-image-target{
  width: 304px;
}

.share-image{
  display: flex;
  justify-content: center;
  align-items: center;
}

.share-cta-row{
  margin-top: 15px;
}
.share-cta{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 65px;
}
@media screen and (min-width: 319px) {
  .share-cta{
    transform: scale(0.9);
  }
}
@media screen and (min-width: 374px) {
  .share-cta{
    transform: scale(1.0);
  }
}

.share-cta-frame{
  position: absolute;
  top: 0px;
  left: calc(50% - 158px)
}

.share-cta-text{
  text-transform: uppercase;
  /* share your radiance: */
  border: 0 solid #FFFFFF;
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 2px;
  text-align: center;
  line-height: 20px;
}

.about-wish-row{
  margin-top: 35px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

}

.about-wish {
  cursor: pointer;
  /* About Wish Children: */
  /* border: 0 solid #CEBC9E; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 14px;
  color: #CEBC9E;
  letter-spacing: 1px;
  text-align: center;
  line-height: 20px;
  border-bottom: #cebc9e solid 1px;
}

.counter-col{
  opacity: 0;
  margin-top: 20px;
  background-color: #F5EEDE;
}
.thank-you{
  text-transform: uppercase;
  /* THANK You for joinin: */
  border: 0 solid #07002A;
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 12px;
  color: #07002A;
  letter-spacing: 1.5px;
  text-align: center;
  line-height: 20px;
}

.counter-top-padding,
.counter-bottom-padding{
  height: 25px;
}

.radiance-collected{
  margin-top: 10px;
  /* Radiance collected: */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 28px;
  color: #573A09;
  letter-spacing: 1px;
  text-align: center;
  line-height: 34px;
}

.radiance-collected-count{
  /* 500: */
  font-family: PlayfairDisplay-Regular, CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 62px;
  color: #07002A;
  letter-spacing: 1.19px;
  text-align: center;
}

.v-line-row{
  display: flex;
  justify-content: center;
  align-items: center;
}

.v-line{
  margin-top: 10px;
  margin-bottom: 10px;
  /* Line 7: */
  width: 1px;
  height: 50px;
  background-color: #CEBC9E;
}


.days-to-go{
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 28px;
  color: #573A09;
  letter-spacing: 1px;
  text-align: center;
  line-height: 34px;
}

.days-to-go-count{
  /* 500: */
  font-family: PlayfairDisplay-Regular, CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 62px;
  color: #07002A;
  letter-spacing: 1.19px;
  text-align: center;
}

/*Share Box*/
.share-box-row{
  margin-top: 10px;
  height: calc(100% - 40px - 48px - 48px);
  display: flex;
  justify-content: center;
  align-items: center;
}
.share-box{
  position: relative;
  width: 304px;
  height: 163px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
.share-frame{
  position: absolute;
  top: 0px;
  left: calc(50% - 304px / 2);
}
.mobile-share{
  display: block;
}
.desktop-share{
  display: none;
}

@media screen and (min-width: 319px) {
  .share-box{
    transform: scale(0.9);
  }
}
@media screen and (min-width: 374px) {
  .share-box{
    transform: scale(1.0);
  }
}

.share-hashtag{
  /* #clédepeauhk #radian: */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 12px;
  color: #CEBC9E;
  letter-spacing: 0.86px;
  text-align: center;
  line-height: 25px;
}

.share-icons{
  width: 188px;
  height: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 2;
}

.share-to{
  text-transform: uppercase;
  /* Share to: */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 14px;
  color: #CEBC9E;
  letter-spacing: 2px;
  text-align: center;
  line-height: 20px;
}

/* pointer */
.pointer{
  cursor: pointer;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 100;
  }
}

.fadeIn{
  animation: fadeIn 1s;
  animation-fill-mode: both;
}

@media screen and (min-width: 767.77px) {
/* @media screen and (min-width: 1439px) { */
  .share-box-row{
    margin-top: 20px;
    height: 240px;
  }
  .share-hashtag{
    font-size: 14px;
  }
  .about-wish{
    font-size: 16px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .thank-you{
    margin-top: 36px;
    font-size: 18px;
  }
  .eng .thank-you{
    margin-top: 36px;
    font-size: 16px;
  }
  .eng .thank-you .number{
    font-size: 19px;
  }
  .thank-you .number{
    font-size: 18px;
  }
  .spark-title-row{
    max-width: 420px;
  }
  .spark-title-con{
    margin-top: 25px;
    font-size: 20px;
    line-height: 30px;
  }
  .share-image-row{
    margin-top: 40px;
    max-width: 450px;
  }
  .effect-filter{
    width: 450px;
    height: 450px;
  }
  .share-image-target{
    width: 450px;
    height: 450px;
  }
  .share-frame{
    width: 320px;
    left: calc(50% - 320px / 2)
  }
  .desktop-share{
    display: block;
  }
  .mobile-share{
    display: none;
  }
  .share-frame.desktop-share{
    width: 480px;
    left: calc(50% - 480px / 2);
  }
  .share-box{
    margin-top: 30px;
    height: 230px;
  }
  .share-to{
    font-size: 18px;
    margin-top: 30px;
  }
  .share-icons{
    width: 260px;
    margin-top: 20px;
  }
  .share-icons img {
    height: 40px;
  }
  .share-hashtag{
    font-size: 18px;
    margin-top: 20px;
  }
  .about-wish-row{
    margin-top: 53px;
  }
  .radiance-collected{
    margin-top: 15px;
    font-size: 40px;
    line-height: 54px;
  }
  .eng .radiance-collected{
    margin-top: 6px;
    font-size: 40px;
    line-height: 54px;
  }
  .radiance-collected-count{
    font-size: 76px;
  }
  .v-line-row{
    margin: 25px 0px;
  }
  .v-line{
    height: 110px;
  }
  .days-to-go-count{
    font-size: 70px;
    margin-top: -17px;
  }
}


.whatsapp{
  transform: translateX(10px);
}
.facebook{
  transform: translateX(10px);
}

</style>



// WEBPACK FOOTER //
// src/components/Pages/SharePage/SharePage.vue